import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tippy from '@tippy.js/react';
import { IconDropDownMo, IconPlus } from 'svgIcons/MotionPortalIcons';
import { echartViews, graphSettings } from './constants';
import { GeneralInput } from 'sharedComponents/GeneralInput';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import IconMinus from 'svgIcons/MotionPortalIcons/IconMinus';

const EchartMoreGraphSetting = (props) => {
    const {
        selectedEchartBandSettings,
        setEchartBandSettings,
        selectedEchartView
    } = props;
    const { t: translate } = useTranslation();

    const visibleGraphSettings = selectedEchartView === echartViews.FREQUENCY
        ? graphSettings.filter((setting) => setting.key === 'filterThreshold')
        : graphSettings;

    const handleInputChange = (settingKey, value) => {
        if (typeof value === 'string' && value.endsWith('.')) {
            value += '1';
        }
        const parseValue = value ? parseFloat(value) : null;
        setEchartBandSettings({
            ...selectedEchartBandSettings,
            moreGraph: {
                ...selectedEchartBandSettings.moreGraph,
                [settingKey]: parseValue >= 0 ? parseValue : null
            },
        });
    };

    const handleNumericbutton = (settingKey, increment) => {
        const currentValue = selectedEchartBandSettings?.moreGraph[settingKey] || 0;
        const newValue = Math.round((currentValue + increment) * 10) / 10;
        handleInputChange(settingKey, newValue);
    };

    const tippyContent = () => <div className='graph-setting-popover'>
        {visibleGraphSettings?.map((setting, index) =>
            <div className='setting-item' key={index}>
                <label>{translate(setting.label)}</label>
                <div className='setting-control'>
                    <GeneralInput
                        numeric={true}
                        placeholder={translate('ABB.Powertrain.Frontend.fftEchartAutoLabel')}
                        value={selectedEchartBandSettings?.moreGraph[setting.key]}
                        onChange={(value) => handleInputChange(setting.key, value)}
                    />
                    <GeneralButton
                        className='subtract'
                        type='normal'
                        text={<IconMinus />}
                        onClick={() => handleNumericbutton(setting.key, -0.1)}
                    />
                    <GeneralButton
                        className='add'
                        type='normal'
                        text={<IconPlus />}
                        onClick={() => handleNumericbutton(setting.key, 0.1)}
                    />
                </div>
            </div>
        )}
    </div>;

    return <div className='more-settings-btn'>
        <Tippy
            content={tippyContent()}
            interactive={true}
            interactiveBorder={10}
            animation='scale'
            theme='light-border graph-setting'
            trigger='click'
            placement='bottom'
            appendTo={() => document.body}
            boundary='window'
        >
            <div className='graph-setting-tippy-content'>
                <div className='title'>{translate('ABB.Powertrain.Frontend.fftEchartgraphSettings')}</div>
                <IconDropDownMo width={8} height={16} />
            </div>
        </Tippy>
    </div>;
};

EchartMoreGraphSetting.propTypes = {
    showHistoricalDialog: PropTypes.bool.isRequired,
    setShowHistoricalDialog: PropTypes.func.isRequired,
    fftTimestampList: PropTypes.shape({
        data: PropTypes.array,
        loadingStatus: PropTypes.string
    }),
    dateSelection: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }),
    setSelectedDates: PropTypes.func.isRequired,
    getFFTTimestampList: PropTypes.func.isRequired,
    getFFTDataByTimestamp: PropTypes.func.isRequired,
    selectedEchartView: PropTypes.string
};

EchartMoreGraphSetting.defaultProps = {
    fftTimestampList: null,
    dateSelection: null,
};

export default EchartMoreGraphSetting;
